module.exports = __webpack_public_path__ + "img/loading.b1d12650.svg";